import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditProfile from "src/components/EditProfile/EditProfile";

import {
  getBMCProfile,
} from "src/redux/slices/bMCProfileSlice";
import "./Profile.scss";
import RegistrationForm from "src/components/Registration/registration";

const Profile = () => {
  const dispatch = useDispatch();
  const name = useSelector(
    (state: any) => state.bMCProfile.BMCData.name
  );
  useEffect(() => {
    if (!name)
      // if company name is not fetched then only fetch the profile
      dispatch(getBMCProfile() as any);
  }, []);
  return (
    <div className={`registration-form-wrapper ps-0`}>
      <div className="registration-form">
        <RegistrationForm isViewMode={true} />
        <EditProfile />
      </div>
    </div>
  );
};

export default Profile;
